export default __webpack_public_path__ + "static/media/945.6915ce42.png";